module.exports = __webpack_public_path__ + "static/media/parch-h25.7fe7a315.jpg";